import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import {
  APPLICATION_WIPE_DATA,
  AI_V2_UPDATE_STATE,
  AI_V2_SET_MESSAGES,
  AI_V2_SET_CONVERSATION_ID,
  AI_V2_CLEAR_CONVERSATION,
  AI_V2_RECEIVE_HANDOFF,
  AI_V2_CLEAR_HANDOFF,
} from '../actions';

const initialState = {
  isChatOpen: false,
  messages: [],
  conversationId: undefined,
  handoffId: undefined,
};

const mergeState = (state, payload) => update(state, { $merge: payload });

const updateChatState = (state, { isChatOpen }) => mergeState(state, { isChatOpen });

const setMessages = (state, { messages }) => mergeState(state, { messages });

const setConversationId = (state, { conversationId }) => mergeState(state, { conversationId });

const clearConversation = state =>
  mergeState(state, {
    messages: [],
    conversationId: undefined,
    handoffId: undefined,
  });

const receiveHandoff = (state, { conversationId, messages, handoffId, isChatOpen }) =>
  mergeState(state, { conversationId, messages, handoffId, isChatOpen });

const clearHandoff = state => mergeState(state, { handoffId: undefined });

const cleanData = () => initialState;

const actionsRepo = {
  [AI_V2_UPDATE_STATE]: updateChatState,
  [AI_V2_SET_MESSAGES]: setMessages,
  [AI_V2_SET_CONVERSATION_ID]: setConversationId,
  [AI_V2_CLEAR_CONVERSATION]: clearConversation,
  [AI_V2_RECEIVE_HANDOFF]: receiveHandoff,
  [AI_V2_CLEAR_HANDOFF]: clearHandoff,
  [APPLICATION_WIPE_DATA]: cleanData,
};

export default createReducer({ initialState, actionsRepo });
